module.exports = __webpack_public_path__ + "static/media/left-slide.e536686e.svg";